import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElaborazioniRoutingModule } from './elaborazioni-routing.module';
import { ElaborazioniService } from './elaborazioni.service';
import { IElaborazione } from './models/elaborazione.model';
import { provideQueryService } from 'src/app/core/services/query.service';
import { ELABORAZIONI_ENDPOINT, elaborazioneStateConfig } from './elaborazioni.config';


@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<IElaborazione>(ELABORAZIONI_ENDPOINT, elaborazioneStateConfig),
    ElaborazioniService
  ],
  imports: [
    CommonModule,
    ElaborazioniRoutingModule
  ]
})
export class ElaborazioniModule { }
